import Axios from 'axios'
import { API_HOST_TOKEN } from '../constants/appConstants'
import { BASE_API } from '../constants/restConstants'

const config = {
  headers: { Authorization: `Bearer ${API_HOST_TOKEN}` },
  params: { populate: '*' },
}

export const getById = (contentType, id) => Axios.get(`${BASE_API}/${contentType}/${id}`, config)

export const getByIdFiltered = (contentType, id, params) =>
  Axios.get(`${BASE_API}/${contentType}/${id}`, { ...config, params })
